import React, { ChangeEvent, useState } from 'react';
import { Input, InputLabel, InputProps } from '@mui/material';

interface Props extends InputProps {
  handler: (e: ChangeEvent<HTMLInputElement>, strings: Array<string>) => void;
  label?: string;
}

const StringArrayInput: React.FC<Props> = (
  {
    handler, label, required, value, ...otherProps
  }: Props,
) => {
  const [
    stringArrayString, setStringArrayString,
  ] = useState(Array.isArray(value) ? value.join(', ') : '');

  const changeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();

    setStringArrayString(e.target.value);

    const strings = e.target.value
      .split(',')
      .map((s) => s.trim().replace('  ', ' '))
      .filter((s) => s);

    handler(e, strings);
  };

  return (
    <>
      {label && <InputLabel required={required} shrink>{label}</InputLabel>}
      <Input
        onChange={changeHandler}
        value={stringArrayString}
        type="text"
        {...otherProps}
      />

    </>

  );
};

export default StringArrayInput;
